module.exports = __webpack_public_path__ + "img/icon_shexiangtou.5857441e.png";